import { createAjaxClient, safeApiCall } from '@/shared/utils/apiHelper';
import { ApiErrorResponse, ApiSuccessResponse } from '@/shared/types/api.types';

import type {
    GetFolderButtonPayload,
    GetFolderButtonResponse
} from '@/shared/DTO/GED';
import type { Payload } from '@/shared/utils/factory';


export async function getFolderButtonInfo(payload: Payload<GetFolderButtonPayload>): Promise<ApiSuccessResponse<GetFolderButtonResponse>> {
    const ajaxClient = createAjaxClient(payload.signal);
    if (payload.signal) {
        delete payload.signal;
    }

    const result = await safeApiCall<GetFolderButtonResponse>(
        ajaxClient('GED/src-GED_load.php', {
            method: 'POST',
            credentials: 'include',
            body: payload,
            query: {
                action: 'get_folder_button_info',
            },
        }),
    );

    if (result instanceof ApiErrorResponse) {
        throw result;
    }

    return result;
}
